import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { paths, productosPath } from '../../helpers/constants';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-firma-modal',
  templateUrl: './firma-modal.component.html',
  styleUrls: ['./firma-modal.component.sass'],
})
export class FirmaModalComponent implements OnInit {
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onClickFirma() {
    this.router.navigate([
      `/${productosPath.path}/${paths.firmaElectronica.path.split('/')[0]}`,
      this.data,
    ]);
  }
}
